module.exports = {
      id: "icon-social-facebook-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-social-facebook",
      toString: function () {
        return this.url;
      }
    }